import classnames from 'classnames';

import style from './ClickOutsideMask.module.scss';

export interface ClickOutsideMaskParams {
    zIndex?: number;
    transparentBackground?: boolean;
    onClickOutside?(): void;
}

interface Props extends ClickOutsideMaskParams {}

export function ClickOutsideMask({ onClickOutside, transparentBackground, zIndex = 0 }: Props) {
    return (
        <div
            className={classnames([style.root, transparentBackground && style.transparentBackground])}
            onClick={onClickOutside}
            style={{ zIndex }}
        />
    );
}
